export default "__VITE_ASSET__BPK$hTsi__"